/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountTransferFundResponse,
  AccountTransferFund: (params: vp.AccountTransferFundRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountTransferFund: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAccountTransferFund, setShouldAccountTransferFund] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountTransferFundRequest>({
    DebitorClientAccountID: '',
    RecipientClientAccountID: '',
    RecipientClientAccountIDSplit: '',
    Amount: 0,
    ClientReferenceNumber: '',
    Notes: '',
    TransactionLabel: '',
    Currency: '',
  });
  const [response, setResponse] = useState<vp.AccountTransferFundResponse>({
    Success: false,
    ErrorMessage: '',
    FundingTransactionID: '',
    AccountTransferID: '',
    AccountTransferIDs: {},
  });

  useEffect(() => {
    if (!shouldAccountTransferFund) return () => {};

    const PostAccountTransferFund = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      // Remove RecipientClientAccountID or RecipientClientAccountIDSplit from params as both cant be passed
      const filteredParams = { ...params };
      if (params.RecipientClientAccountIDSplit !== '') {
        delete filteredParams.RecipientClientAccountID;
      } else {
        delete filteredParams.RecipientClientAccountIDSplit;
      }

      const res = await api.postAccountTransferFund(filteredParams, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAccountTransferFund) void PostAccountTransferFund();
    setShouldAccountTransferFund(false);
    return () => {
      source.cancel();
    };
  }, [shouldAccountTransferFund]);

  return [
    response,
    (_params: vp.AccountTransferFundRequest) => {
      setParams(_params);
      setShouldAccountTransferFund(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        FundingTransactionID: '',
        AccountTransferID: '',
        AccountTransferIDs: {},
      });
      setShouldAccountTransferFund(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountTransferFund);
